<template>
  <section v-if="props.destination || props.themes.length > 0" aria-labelledby="theme-navigation-heading" class="pb-7 md:px-4 md:pb-14" data-testid="theme-navigation-section">
    <div class="md:m-auto md:w-11/12 md:max-w-[1216px]">
      <h3 id="theme-navigation-heading" class="mb-5 ml-4 font-Spectral text-xl tracking-wide md:mb-4 md:ml-0 md:text-[26px] md:leading-[40px]">
        <div class="flex items-center">
          Explore by Destination & Theme
          <span class="mx-2 flex flex-grow items-center">
            <span class="h-[0.5px] flex-grow bg-beige3"></span>
          </span>
        </div>
      </h3>
      <div class="space-y-4 px-4 md:px-0">
        <div v-if="props.destination" class="flex items-start gap-2">
          <img alt="" class="size-6 shrink-0" :src="locationOnIcon" />
          <NuxtLink class="font-Spectral text-gold1 underline decoration-gold4/50 underline-offset-[6px] transition-colors hover:decoration-gold1 md:text-lg" :to="props.destination.path">{{
            props.destination.name
          }}</NuxtLink>
        </div>
        <div v-if="props.themes.length > 0" class="flex items-start gap-2">
          <img alt="" class="size-6 shrink-0" :src="hashtagIcon" />
          <div class="flex flex-wrap gap-x-6 gap-y-3">
            <NuxtLink
              v-for="theme in props.themes"
              :key="theme.path"
              class="font-Spectral text-gold1 underline decoration-gold4/50 underline-offset-[6px] transition-colors hover:decoration-gold1 md:text-lg"
              :to="theme.path"
              >{{ theme.name }}</NuxtLink
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import hashtagIcon from '@/assets/icon/hashtag/gray.svg';
import locationOnIcon from '@/assets/icon/wabunka/location_on.svg';
import type { HubLink } from '@/wabunka-src/features/Experience/models/wabunkaExperienceTagHubLink';

interface Props {
  destination?: HubLink;
  themes: HubLink[];
}

const props = defineProps<Props>();
</script>
